import { render, staticRenderFns } from "./nba-unopen-card.vue?vue&type=template&id=4de8b4b2&scoped=true&lang=pug&"
import script from "./nba-unopen-card.vue?vue&type=script&lang=js&"
export * from "./nba-unopen-card.vue?vue&type=script&lang=js&"
import style0 from "./nba-unopen-card.vue?vue&type=style&index=0&id=4de8b4b2&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4de8b4b2",
  null
  
)

export default component.exports